import { LANDSCAPE_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/landscapeBackdrops';
import { aridBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Savanna — Goldengrass Savanna at golden hour: a warm hazy dusk sky with drifting amber cloud
 *  bands, a big LOW warm sun + halo low on the horizon, golden dust + pollen motes adrift, warm
 *  low-angle sun shafts, a breathing sun-bloom bed, golden dust streaming on a dry breeze, a faint
 *  grass-level heat shimmer, layered flat-topped acacia silhouettes, a warm vignette, and a golden
 *  grade. The dry warm grassland gap between MEADOW (green) and DESERT (sand) — amber GOLD at dusk,
 *  open + arid-but-alive. Contrast kept (dark tree silhouettes against the bright gold sky, no wash). */
export const SAVANNA = aridBiome({
  id: 'savanna',
  sky: { from: 0xbf7a4e, to: 0xf5c66a },
  celestial: { atX: 0.74, atY: 0.64, color: 0xff9a40, haloColor: 0xffce82, size: 120, haloScale: 3.2, coreAlpha: 0.85, haloAlpha: 0.24 },
  cloudBands: { count: 5, color: 0xffd9a0, sizeMin: 380, sizeMax: 680, alphaMin: 0.05, alphaMax: 0.13, driftPxPerSec: 6, bandYMin: 0.08, bandYMax: 0.3 },
  motes: { colors: [P.firefly, P.sand, P.amber] },
  rays: { color: 0xffd27a, tiltDeg: 14, alphaMax: 0.32 },
  glow: {
    blobs: [
      { color: 0xffb454, atX: 0.74, atY: 0.6, size: 440, alpha: 0.09 },
      { color: P.dune, atX: 0.5, atY: 0.97, size: 600, alpha: 0.08 },
    ],
    breathe: { periodMs: 6200, min: 0.82, max: 1.22 },
  },
  lightField: { palette: [P.sunHaze, P.amber, P.dune] },
  weather: { mode: 'fall', color: 0xf2cf86, colorEnd: 0xddb066,
    size: 6, frequencyMs: 100, lifespanMs: 4800, speed: 15, gravityY: 5, windX: 52,
    gust: { periodMs: 8000, min: 0.5, max: 1.5, phase: 0.3 } },
  flicker: { color: 0xffd98a },
  parallax: [
    { svg: LANDSCAPE_BACKDROPS.savanna.far, shape: 'peaks', color: 0x7a5532, speed: 0.04, height: 360, alpha: 0.7, detail: 0.8, sway: { ampPx: 8, periodMs: 30000 } },
    { svg: LANDSCAPE_BACKDROPS.savanna.mid, shape: 'peaks', color: 0x523620, speed: 0.10, height: 260, alpha: 0.85, detail: 1.1 },
    { svg: LANDSCAPE_BACKDROPS.savanna.near, shape: 'ridge', color: 0x35200f, speed: 0.18, height: 150, alpha: 0.94, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x4a2f16, edgeAlpha: 0.28, washColor: 0xffb84a, washAlpha: 0.05 },
    grade: { top: 0xffd584, bottom: 0xc98a3e, strength: 0.1, blend: 'normal' },
  },
});
